import React, { useMemo } from 'react'
import languages from 'data/languages/list'
import languageNames from 'data/languages/messages'
import products from 'data/products/list'
import productNames from 'data/products/messages'
import mediums from 'data/mediums/list'
import mediumNames from 'data/mediums/messages'
import { frontPageGenders as genders } from 'data/genders/list'
import genderNames from 'data/genders/messages'
import filterMessages from 'data/filters/messages'
import { Select } from '@arnsbogroup/react-voicearchive'
import { FormattedMessage, useIntl } from 'react-intl'
import useBreakpoint from 'hooks/useBreakpoint'
import classNames from 'classnames'

const Filters = ({
  dispatch,
  project,
  filters = { languages: null, categories: null, gender: null },
  className = '',
  containerStyles = {},
}) => {
  const bp = useBreakpoint()
  const { formatMessage } = useIntl()

  const _filters = useMemo(
    () =>
      [
        [
          'languages',
          languages,
          languageNames,
          (opt) => ({
            type: 'SET_LANGUAGES',
            payload: opt.map(({ value }) => value),
          }),
          true,
        ],
        [
          'gender',
          genders,
          genderNames,
          (opt) => ({ type: 'SET_GENDERS', payload: [opt.value] }),
          false,
        ],
        [
          'categories',
          products,
          productNames,
          (opt) => ({
            type: 'SET_CATEGORIES',
            payload: opt.map(({ value }) => value),
          }),
          true,
        ],
        [
          'mediums',
          mediums,
          mediumNames,
          (opt) => ({
            type: 'SET_MEDIUMS',
            payload: opt.map(({ value }) => value)
          }),
          true
        ],
      ]
        .filter(([key]) => Object.keys(filters).includes(key))
        .map(([key, items, names, func, isMulti = false]) => ({
          id: key,
          placeholder: filterMessages[key]
            ? formatMessage(filterMessages[key])
            : 'N/A',
          onChange: (opts) => dispatch(func(opts)),
          isMulti,
          options: items
            .filter((item) =>
              filters[key] ? filters[key].includes(item.key) : true
            )
            .map((item) => ({
              value: item.key,
              label: names[item.key] ? formatMessage(names[item.key]) : 'N/A',
            }))
            .sort((x, y) => {
              let a = x.label.toUpperCase(),
                b = y.label.toUpperCase()
              return a == b ? 0 : a > b ? 1 : -1
            }),
        }))
        .map((filter) => ({
          ...filter,
          value:
            filter.options.filter(({ value }) => {
              if (Array.isArray(project[filter.id])) {
                return project[filter.id].includes(value)
              }

              return value === project[filter.id]
            }) || null,
        })),
    [project]
  )

  return (
    <React.Fragment>
      {_filters.map(
        ({ id, options, onChange, value, placeholder, isMulti }) => (
          <Select
            className={classNames('inline-block w-auto relative text-sm md:text-base', className)}
            size={{ sm: 'sm' }[bp] || 'base'}
            key={id}
            instanceId={id}
            options={options}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            floatingLabel={placeholder}
            isMulti={isMulti}
            styles={{
              container: (provided, state) => ({
                ...provided,
                width: 'max-content',
                ...containerStyles,
              }),
            }}
          />
        )
      )}
    </React.Fragment>
  )
}

export default Filters
